import * as ActionTypes from './UserStatisticActionsTypes';
import { IUserStatistic } from './IUserStatisticActions';
import { TReserve } from '../../types/IBookingStore';

/** @description Экшен на получение статистики юзера */
export function getUserStatistic(userPhoneNumber: string, sort: { orderBy: string; order: "desc" | "asc" }, page: number, pageSize: number): IUserStatistic {
  return {
    type: ActionTypes.GET_USER_STATISTIC_REQUEST,
    payload: {
      userPhoneNumber,
      sort,
      page,
      pageSize,
    },
  };
}

/** @description Экшен на обработку получения статистики юзера */
export function getUserStatisticSuccess(
  userInfo: any, userStats: any, userReserves: Array<TReserve>, totalCount: number, totalPage: number
): IUserStatistic {
  return {
    type: ActionTypes.GET_USER_STATISTIC_SUCCESS,
    payload: {
      userInfo,
      userStats,
      userReserves,
      totalCount,
      totalPage,
    },
  };
}

/** @description Экшен на обработку ошибки получения статистики юзера */
export function getUserStatisticsError(): IUserStatistic {
  return {
    type: ActionTypes.GET_USER_STATISTIC_ERROR,
    error: 'Не удалось получить информацию о госте',
  };
}
